import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../Styles/Employee.css';
import History from './History';
import logo from './../Images/tsqs-hm-ft-logo1.gif';
import ProfileDialog from './ProfileDialog';
import AppHeader from './AppHeader';
import GoalAssessmentTable from './GoalAssessmentTable';

const apiUrl = process.env.REACT_APP_API_URL;

const Employee = () => {
    const [currentSection, setCurrentSection] = useState('goals');
    const [employeeInfo, setEmployeeInfo] = useState({ fullName: '', jobTitle: '', employee_number: '' });
    const [isProfileDialogOpen, setProfileDialogOpen] = useState(false);

    useEffect(() => {
        const fetchEmployeeData = async () => {
            const employeeId = localStorage.getItem('employeeId');
            if (!employeeId) {
                console.error('Employee ID not found in local storage.');
                return;
            }
            try {
                const employeeResponse = await axios.get(`${apiUrl}/api/employee-info/${employeeId}`);
                setEmployeeInfo(employeeResponse.data);
            } catch (error) {
                console.error('Error fetching employee info:', error);
            }
        };

        fetchEmployeeData();
    }, []);

    const handleOpenProfileDialog = () => {
        setProfileDialogOpen(true);
    };

    const handleCloseProfileDialog = () => {
        setProfileDialogOpen(false);
    };

    return (
        <div className="admin-page">
            {/* Sidebar */}
            <aside className="sidebar">
                <div className="logo-container">
                    <img src={logo} alt="Company Logo" className="logo" />
                </div>
                <nav className="nav-menu">
                    <a
                        href="#"
                        className={`nav-item ${currentSection === 'goals' ? 'active' : ''}`}
                        onClick={(e) => { e.preventDefault(); setCurrentSection('goals'); }}
                    >
                        Goals
                    </a>
                    <a
                        href="#"
                        className={`nav-item ${currentSection === 'submitted' ? 'active' : ''}`}
                        onClick={(e) => { e.preventDefault(); setCurrentSection('submitted'); }}
                    >
                        Submitted
                    </a>
                </nav>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                <AppHeader
                    title="PERFORMANCE MANAGEMENT SYSTEM"
                    employeeInfo={employeeInfo}
                    onProfileClick={handleOpenProfileDialog}
                    hideLogo={true}
                />

                {currentSection === 'submitted' && <History embedded={true} />}

                {currentSection === 'goals' && (
                    <>
                        <div className="welcome-section">
                            <h1>Hi {employeeInfo.fullName || employeeInfo.full_name}...</h1>
                        </div>
                        <GoalAssessmentTable 
                            employeeId={employeeInfo.employee_number || localStorage.getItem('employeeId')} 
                        />
                    </>
                )}
            </main>

            {isProfileDialogOpen && (
                <ProfileDialog
                    employeeInfo={employeeInfo}
                    onClose={handleCloseProfileDialog}
                    onUpdate={(updatedData) => setEmployeeInfo(prev => ({ ...prev, ...updatedData }))}
                />
            )}
        </div>
    );
};

export default Employee;
